import React, { useEffect, useState } from 'react';
import { IdRegistration, Opdrachtgever, Verdieping } from 'src/common/types';

import { useFetch } from 'src/hooks/useFetch';

type ExportRegistrationsButtonProps = {
  name: string;
  data: IdRegistration[];
  opdrachtgever: Opdrachtgever;
};

const headers = [
  'Controllernaam',
  'DOI',
  'Installatie',
  'Verdieping',
  'Bouwdeel',
  'Locatie',
  'Vendor',
  'Vendortype',
  'IP-adres',
  'VLAN',
  'MAC-adres',
  'Technical Outlet',
  'Notitie',
];

export const ExportRegistrationsButton = (props: ExportRegistrationsButtonProps) => {
  const { data: verdiepingData } = useFetch<Verdieping[]>('/api/verdieping', { defaultValue: [] });

  const [gateways, setGateways] = useState<{ [key: string]: { [key: string]: string } }>({});
  useEffect(() => {
    const result = {} as { [key: string]: { [key: string]: string } };
    props.opdrachtgever.bouwdelen.forEach(bouwdeel => {
      result[bouwdeel.id] = {};
      bouwdeel.gateways.forEach(gateway => {
        result[bouwdeel.id][gateway.ip_address] = gateway.vlan || '';
      });
      setGateways(result);
    });
  }, [props.opdrachtgever]);

  const getVLAN = (reg: IdRegistration) => {
    const id = reg.bouwdeel?.id || reg.project?.bouwdeel_id;
    if (!id) return '';
    return gateways[id][reg.gateway] || '';
  };

  const convertData = () => {
    const verdiepingenByKey = verdiepingData.reduce(
      (result, current) => {
        result[current.code] = current.name;
        return result;
      },
      {} as { [key: string]: string }
    );
    props.data.forEach(reg => {
      reg.controller_name =
        reg.controller_name || ((reg.project?.bouwdeel || reg.bouwdeel)?.name || '') + reg.location + 'D' + (reg.doi || '');
    });
    return (
      headers.join(',') +
      '\n' +
      props.data
        .map(reg => {
          return [
            reg.controller_name,
            reg.doi,
            reg.installation,
            verdiepingenByKey[reg.floor],
            (reg.project?.bouwdeel || reg.bouwdeel)?.name || '',
            reg.location,
            reg.vendor?.name || '',
            reg.vendortype?.name || '',
            reg.ip_address,
            getVLAN(reg),
            reg.mac_address,
            reg.to,
            reg.notes,
          ].join(',');
        })
        .join('\n')
    );
  };

  const exportData = () => {
    const blob = new Blob([convertData()], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = props.name + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <button onClick={() => exportData()}>Export</button>
    </>
  );
};
